import { useEffect, useState } from 'react'

import { MOBILE_MAX_VIEWPORT_WIDTH } from './mobileGridLayout'

const QUERY = `(max-width: ${MOBILE_MAX_VIEWPORT_WIDTH}px)`

export const useIsMobileViewport = () => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(QUERY).matches)

  useEffect(() => {
    const query = window.matchMedia(QUERY)

    const update = (event: MediaQueryListEvent) => setIsMobile(event.matches)

    setIsMobile(query.matches)
    query.addEventListener('change', update)

    return () => query.removeEventListener('change', update)
  }, [])

  return isMobile
}
